export const AUTH_TOKEN = 'auth-token'
export const MAX_INT = 214748364